import { Users, AlertCircle, Send } from 'lucide-react';
import { Button } from '../../ui/button';

export function TokenHoldersList({ tokenHolders, onDistributeClick }) {
  return (
    <div className="glass-card p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-semibold flex items-center gap-2">
          <Users className="w-5 h-5 text-cyan-400" />
          Current Token Holders
        </h3>
        <Button
          onClick={onDistributeClick}
          disabled={tokenHolders.length === 0}
          className="bg-green-500 hover:bg-green-600"
          data-testid="distribute-btn"
        >
          <Send className="w-4 h-4 mr-2" />
          Distribute Royalties
        </Button>
      </div>

      {tokenHolders.length === 0 ? (
        <div className="text-center py-8 bg-white/5 rounded-lg">
          <AlertCircle className="w-12 h-12 text-yellow-500 mx-auto mb-3" />
          <p className="text-gray-400">No token holders for this track</p>
          <p className="text-sm text-gray-500 mt-1">
            Royalties can only be distributed once fans purchase ownership tokens
          </p>
        </div>
      ) : (
        <div className="space-y-3">
          {tokenHolders.map((holder) => (
            <div 
              key={holder.user_id}
              className="flex items-center justify-between p-4 bg-white/5 rounded-lg"
              data-testid={`holder-${holder.user_id}`}
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-500 to-cyan-500 flex items-center justify-center">
                  <span className="text-sm font-bold">
                    {holder.user_email?.charAt(0).toUpperCase() || '?'}
                  </span>
                </div>
                <div>
                  <p className="font-medium">{holder.user_email || holder.user_id}</p>
                  <p className="text-sm text-gray-400">Token Holder</p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-xl font-bold text-cyan-400">{holder.tokens_owned}%</p>
                <p className="text-xs text-gray-500">ownership</p>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
